import { createSlice } from '@reduxjs/toolkit';

const partnerSlice = createSlice({
  name: 'partner',
  initialState: {
    list: [],
  },
  reducers: {
    setPartner: (state, action) => {
      state.list = action.payload;
    },
    addPartner: (state, action) => {
      state.list.push(action.payload);
    },
    updatePartner: (state, action) => {
      const index = state.list.findIndex(product => product._id === action.payload._id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },
 
        deletePartner: (state, action) => {
        state.list = state.list.filter(product => product._id !== action.payload);
        }

  },
});

export const {
  setPartner,
  addPartner,
  updatePartner,
  deletePartner
} = partnerSlice.actions;

export default partnerSlice.reducer;
